/**
 * Function that throws if value is nullish.
 */
export function assertNotNullish(value, msg = '') {
    if (value == null) {
        throw new Error(`Nullish assertion error. ${msg}`);
    }
}
//# sourceMappingURL=assertNotNullish.js.map